import styled from "styled-components";

interface ButtonProps {
  secondary?: boolean;
  gcblue?: boolean;
  sm?: boolean;
  full?: boolean;
  withArrow?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, disabled, secondary, gcblue }) =>
    disabled
      ? secondary || gcblue
        ? "transparent"
        : "#D4D4D4"
      : gcblue
        ? "#D7F2FE"
        : secondary
          ? "transparent"
          : theme.colors.primary};
  border-style: ${({ secondary, gcblue }) =>
    secondary || gcblue ? "solid" : "none"};
  border-width: ${({ secondary, gcblue }) => (secondary || gcblue ? "1px" : 0)};
  border-color: ${({ secondary, gcblue, disabled }) =>
    secondary || gcblue ? (disabled ? "#E6E6E6" : "#EAECF0") : "transparent"};
  padding: ${({ sm }) => (sm ? "8px 12px" : "12px 40px")};
  font-size: ${({ sm }) => (sm ? "13px" : "15px")};
  border-radius: 30px;
  font-weight: bold;
  width: ${({ full }) => (full ? "100%" : "auto")};
  color: ${({ secondary, gcblue, disabled }) =>
    disabled
      ? secondary || gcblue
        ? "#E6E6E6"
        : "#fff"
      : gcblue
        ? "#344054"
        : secondary
          ? "#344054"
          : "#fff"};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  transition: all 0.3s;
  box-shadow: ${({ secondary, gcblue, disabled }) =>
    disabled || secondary || gcblue ? "none" : "0 0 0 rgba(255, 255, 255, 0)"};

  &:hover {
    color: ${({ secondary, gcblue, disabled }) =>
      gcblue ? "#344054" : secondary ? "#FF5A6A" : disabled ? "#fff" : "#fff"};
    border-color: ${({ secondary, gcblue }) =>
      gcblue ? "#EAECF0" : secondary ? "#FF5A6A" : "transparent"};
    box-shadow: ${({ secondary, gcblue, disabled }) =>
      disabled || secondary || gcblue
        ? "none"
        : "0 8px 16px rgba(255, 90, 106, .2)"};
  }

  ::after {
    display: ${({ withArrow }) => (withArrow ? "inline-flex" : "none")};
    content: " ";
    width: 20px;
    height: 20px;
    mask: url("/images/ChevronRight.svg") 0 0 no-repeat;
    mask-size: cover;
    background-color: ${({ secondary, gcblue, disabled, theme }) =>
      disabled
        ? secondary || gcblue
          ? "#E6E6E6"
          : "#fff"
        : gcblue
          ? theme.colors.primary
          : secondary
            ? theme.colors.primary
            : "#fff"};
    margin-left: 6px;
    margin-right: -6px;
  }
`;
